<script>
import { defineAsyncComponent, ref, computed } from 'vue';

import NextSidebar from 'next/sidebar/Sidebar.vue';
// BonBoZ: thanh tren de chuyen giua cac phan lon (bo cuc kieu Pancake)
import TopBar from 'dashboard/components/TopBar.vue';
import ErrorBoundary from 'dashboard/components/ErrorBoundary.vue';
import WootKeyShortcutModal from 'dashboard/components/widgets/modal/WootKeyShortcutModal.vue';
import AddAccountModal from 'dashboard/components/app/AddAccountModal.vue';
import UpgradePage from 'dashboard/routes/dashboard/upgrade/UpgradePage.vue';

import { useUISettings } from 'dashboard/composables/useUISettings';
import { useAccount } from 'dashboard/composables/useAccount';
import { useWindowSize } from '@vueuse/core';

import wootConstants from 'dashboard/constants/globals';

const CommandBar = defineAsyncComponent(
  () => import('./commands/commandbar.vue')
);

const FloatingCallWidget = defineAsyncComponent(
  () => import('dashboard/components-next/call/FloatingCallWidget.vue')
);

// BonBoZ: thẻ nổi "khách mới nhắn". Mount ở root dashboard cạnh FloatingCallWidget
// vì thẻ phải sống qua mọi lần đổi route, không riêng màn Hội thoại.
import NewMessagePingStack from 'dashboard/components/NewMessagePingStack.vue';
// BonBoZ: dai nhac bat thong bao. Quyen chi xin duoc tu mot cu bam that, va
// khong ai tu vao Cai dat de bam - xem chinh component.
import NotificationPermissionBanner from 'dashboard/components/NotificationPermissionBanner.vue';
// BonBoZ: banner báo điện thoại không nhận được thông báo, hiện trên mọi máy.
// Khi banner này hiện thì dải nhắc ở trên tự ẩn.
import PushHealthBanner from 'dashboard/components/PushHealthBanner.vue';
// BonBoZ: popup cuộc gọi Zalo. Mount ở root dashboard vì chuông phải reo dù
// nhân viên đang ở màn nào.
import ZaloCallDialog from 'dashboard/routes/dashboard/mainPage/CuocGoiZaloDialog.vue';
import CopilotLauncher from 'dashboard/components-next/copilot/CopilotLauncher.vue';
import CopilotContainer from 'dashboard/components/copilot/CopilotContainer.vue';

import { useCallsStore } from 'dashboard/stores/calls';

export default {
  components: {
    NextSidebar,
    TopBar,
    ErrorBoundary,
    CommandBar,
    WootKeyShortcutModal,
    AddAccountModal,
    UpgradePage,
    CopilotLauncher,
    CopilotContainer,
    FloatingCallWidget,
    NewMessagePingStack,
    NotificationPermissionBanner,
    PushHealthBanner,
    ZaloCallDialog,
  },
  setup() {
    const upgradePageRef = ref(null);
    const { uiSettings, updateUISettings } = useUISettings();
    const { accountId } = useAccount();
    const { width: windowWidth } = useWindowSize();
    const callsStore = useCallsStore();

    return {
      uiSettings,
      updateUISettings,
      accountId,
      upgradePageRef,
      windowWidth,
      hasActiveCall: computed(() => callsStore.hasActiveCall),
      hasIncomingCall: computed(() => callsStore.hasIncomingCall),
    };
  },
  data() {
    return {
      showAccountModal: false,
      showCreateAccountModal: false,
      showShortcutModal: false,
      isMobileSidebarOpen: false,
    };
  },
  computed: {
    isSmallScreen() {
      return this.windowWidth < wootConstants.SMALL_SCREEN_BREAKPOINT;
    },
    showUpgradePage() {
      return this.upgradePageRef?.shouldShowUpgradePage;
    },
    bypassUpgradePage() {
      return [
        'billing_settings_index',
        'settings_inbox_list',
        'general_settings_index',
        'agent_list',
      ].includes(this.$route.name);
    },
    previouslyUsedDisplayType() {
      const {
        previously_used_conversation_display_type: conversationDisplayType,
      } = this.uiSettings;
      return conversationDisplayType;
    },
  },
  watch: {
    isSmallScreen: {
      handler() {
        const { LAYOUT_TYPES } = wootConstants;
        if (window.innerWidth <= wootConstants.SMALL_SCREEN_BREAKPOINT) {
          this.updateUISettings({
            conversation_display_type: LAYOUT_TYPES.EXPANDED,
          });
        } else {
          this.updateUISettings({
            conversation_display_type: this.previouslyUsedDisplayType,
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeMobileSidebar() {
      this.isMobileSidebarOpen = false;
    },
    openCreateAccountModal() {
      this.showAccountModal = false;
      this.showCreateAccountModal = true;
    },
    closeCreateAccountModal() {
      this.showCreateAccountModal = false;
    },
    toggleAccountModal() {
      this.showAccountModal = !this.showAccountModal;
    },
    toggleKeyShortcutModal() {
      this.showShortcutModal = true;
    },
    closeKeyShortcutModal() {
      this.showShortcutModal = false;
    },
  },
};
</script>

<template>
  <!-- BonBoZ: vo app xep DOC - thanh tren truoc, roi moi toi hang
       (rail trai + noi dung). Truoc day chi co mot hang ngang. -->
  <div class="flex flex-col flex-grow overflow-hidden text-n-slate-12">
    <ErrorBoundary ten="PushHealthBanner">
      <PushHealthBanner />
    </ErrorBoundary>
    <NotificationPermissionBanner />
    <!-- BonBoZ: nen khung (mau hoac gradient theo chu de) to o the boc NAY, roi
         thanh tren va rail trong suot de lo ra — nho vay gradient lien mach qua
         ca hai. Banner nhac thong bao nam NGOAI the boc vi no ban trong suot,
         de len nen khung thi thanh mot mau lai. Xem `helper/chuDe.js`. -->
    <div
      class="flex flex-col flex-grow min-h-0 overflow-hidden bonboz-khung-nen"
    >
      <ErrorBoundary ten="TopBar">
        <TopBar @open-key-shortcut-modal="toggleKeyShortcutModal" />
      </ErrorBoundary>
      <!-- Nen khung o hang nay chi lo ra o goc bo tron cua <main>, phan con lai
         bi rail va noi dung phu kin. -->
      <div class="flex flex-grow overflow-hidden min-h-0">
        <!-- BonBoZ: an han thanh trai duoi 768px. No chi con la RAIL LOC hoi thoai
           (moi muc dieu huong da bi `helper/sidebarVisibility.js` an), ma tren
           dien thoai flyout do mo ra RONG KHONG - khong mot muc nao de bam. Menu
           ho so da chuyen len thanh tren cung dot nay.
           `md:contents` de tu 768px tro len the boc nay bien mat khoi bo cuc,
           thanh trai nam dung cho cu trong hang flex. -->
        <div class="hidden md:contents">
          <NextSidebar
            :is-mobile-sidebar-open="isMobileSidebarOpen"
            @toggle-account-modal="toggleAccountModal"
            @open-key-shortcut-modal="toggleKeyShortcutModal"
            @close-key-shortcut-modal="closeKeyShortcutModal"
            @show-create-account-modal="openCreateAccountModal"
            @close-mobile-sidebar="closeMobileSidebar"
          />
        </div>

        <!-- Bo goc tren trai de thanh tren va rail om lay noi dung nhu Pancake,
           thay vi ba mang vuong gap nhau. Dat o day nen moi trang deu co. -->
        <main
          class="flex flex-1 h-full w-full min-h-0 px-0 overflow-hidden bg-n-surface-1 rounded-tl-2xl"
        >
          <UpgradePage
            v-show="showUpgradePage"
            ref="upgradePageRef"
            :bypass-upgrade-page="bypassUpgradePage"
          />
          <template v-if="!showUpgradePage">
            <router-view />
            <CommandBar />
            <CopilotLauncher />
            <CopilotContainer />
            <FloatingCallWidget v-if="hasActiveCall || hasIncomingCall" />
            <NewMessagePingStack />
            <ZaloCallDialog />
          </template>
          <AddAccountModal
            :show="showCreateAccountModal"
            @close-account-create-modal="closeCreateAccountModal"
          />
          <WootKeyShortcutModal
            v-model:show="showShortcutModal"
            @close="closeKeyShortcutModal"
            @clickaway="closeKeyShortcutModal"
          />
        </main>
      </div>
    </div>
  </div>
</template>
